const websocketBaseUrl =
  process.env.NEXT_PUBLIC_WEBSOCKET_URL || 'wss://api.obraplay.com';

export const quotationAnswerWebsocketUrl = (quotation_answer_id: number) =>
  `${websocketBaseUrl}/ws/quotation_answers/${quotation_answer_id}/`;

export const orderWebsocketUrl = (order_id: number) =>
  `${websocketBaseUrl}/ws/orders/${order_id}/`;

export const UserMeWebsocketUrl = (access: string) =>
  `${websocketBaseUrl}/ws/users/me/?access=${access}`;

export const QuotationComparativeWebsocketUrl = (
  quotation_id: number,
  access: string
) =>
  `${websocketBaseUrl}/ws/quotations/${quotation_id}/comparative/?access=${access}`;
